import { useState, useEffect } from 'react';
import axios from 'axios';
import { useAuth } from '../contexts/AuthContext';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

/**
 * Hook to fetch client/HQ requirements including:
 * - Caller number masking
 * - WhatsApp number masking
 * - Telephony provider (PBX or Plivo)
 * - PBX configuration details
 */
export const useClientRequirements = () => {
  const [requirements, setRequirements] = useState({
    caller_number_masking: false,
    whatsapp_number_masking: false,
    telephony_provider: 'plivo',
    pbx_api_url: '',
    pbx_extension: '',
    admin_id: null
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const { user, isAuthenticated, businessUnit } = useAuth();

  useEffect(() => {
    const fetchRequirements = async () => {
      if (!isAuthenticated || !user) {
        setLoading(false);
        return;
      }

      try {
        setLoading(true);
        
        // Get auth token from RBAC session
        const rbacSessionStr = sessionStorage.getItem('rbac_session');
        let token = null;
        if (rbacSessionStr) {
          try {
            const rbacSession = JSON.parse(rbacSessionStr);
            token = rbacSession.token;
          } catch (e) {
            console.error('Error parsing RBAC session:', e);
          }
        }

        if (!token) {
          console.warn('No RBAC token available for requirements fetch');
          setLoading(false);
          return;
        }

        // Fetch requirements from the backend
        const response = await axios.get(`${API_BASE_URL}/admin-requirements/rbac`, {
          headers: { Authorization: `Bearer ${token}` }
        });

        if (response.data.success || response.data.data) {
          const data = response.data.data || response.data;
          setRequirements({
            caller_number_masking: data.caller_number_masking || false,
            whatsapp_number_masking: data.whatsapp_number_masking || false,
            telephony_provider: data.telephony_provider || 'plivo',
            pbx_api_url: data.pbx_api_url || '',
            pbx_extension: data.pbx_extension || '',
            admin_id: data.admin_id || null,
            whatsapp_quotations: data.whatsapp_quotations || false
          });
        }
      } catch (err) {
        console.error('Error fetching requirements:', err);
        setError(err.message);
        // Don't block on requirements fetch failure
      } finally {
        setLoading(false);
      }
    };

    fetchRequirements();
  }, [isAuthenticated, user, businessUnit]);

  return { requirements, loading, error };
};
